/**
 * Registration API
 * 라이더 회원가입 관련 API 호출 함수
 */

import { apiClient } from '../../../core/api/client';
import {
    RegistrationRequestParams,
    RegistrationRequestResponse,
    RegistrationVerifyParams,
    RegistrationVerifyResponse,
    RegistrationCompleteParams,
    RegistrationCompleteResponse,
} from '../types/registration';

const BASE_PATH = '/api/v1/mob/login';

/**
 * 회원가입 이메일 요청 API
 * POST /api/v1/mob/login/registration/request
 * @param params 라이더 ID와 이메일
 * @returns 이메일 발송 결과
 */
export const requestRegistrationEmail = async (
    params: RegistrationRequestParams
): Promise<RegistrationRequestResponse> => {
    const response = await apiClient.post<RegistrationRequestResponse>(
        `${BASE_PATH}/registration/request`,
        params
    );
    return response.data;
};

/**
 * 회원가입 토큰 검증 API
 * POST /api/v1/mob/login/registration/verify
 * @param params 토큰
 * @returns 라이더 정보
 */
export const verifyRegistrationToken = async (
    params: RegistrationVerifyParams
): Promise<RegistrationVerifyResponse> => {
    const response = await apiClient.post<RegistrationVerifyResponse>(
        `${BASE_PATH}/registration/verify`,
        params
    );
    return response.data;
};

/**
 * 회원가입 완료 API
 * POST /api/v1/mob/login/registration/complete
 * @param params 토큰, 비밀번호, 휴대폰번호, 이메일
 * @returns 로그인 정보 (토큰 포함)
 */
export const completeRegistration = async (
    params: RegistrationCompleteParams
): Promise<RegistrationCompleteResponse> => {
    const response = await apiClient.post<RegistrationCompleteResponse>(
        `${BASE_PATH}/registration/complete`,
        params
    );
    return response.data;
};
